<template>
  <v-container>
    <!--    npm install vue2-editor-->
    <div v-if="loading">
      <v-progress-linear
          indeterminate
          color="green"
      ></v-progress-linear>
      <p>
        لطفا صبر کنید
      </p>
    </div>
    <v-row v-else justify="center">
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title style="word-break: normal;">
            عنوان خبر:
            <br/>
            {{ data.title }}
          </v-card-title>
          <v-card-text>
            <v-img max-height="450" contain :src="data.image">
            </v-img>
            <span>{{ data.year }}-{{ data.month }}-{{ data.day }}</span>
            <br/>
            <br/>
            <h3>
              خلاصه خبر:
            </h3>
            {{ data.description }}
            <br/>
            <br/>
            <h3>
              متن خبر:
            </h3>
            <div v-html="data.content">
            </div>

          </v-card-text>
          <v-card-actions>
            <v-row>

              <v-col cols="4">
                <v-btn color="primary" block @click="$store.commit('open_edit_news_dialog')">
                  ویرایش خبر
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-btn color="primary" block @click="$store.commit('open_edit_news_pic_dialog')">
                  تغییر تصویر
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-btn color="error" block
                       @click="$store.commit('open_delete_news_dialog',{id: data.id, title:data.title, list:false})">
                  حذف خبر
                </v-btn>
              </v-col>
            </v-row>


          </v-card-actions>
        </v-card>

      </v-col>
    </v-row>
    <edit-news-dialog/>
    <edit-news-pic-dialog/>
    <delete-news-dialog/>
  </v-container>
</template>

<script>
import {mapState} from "vuex";
import EditNewsDialog from "@/components/admin/News/Dialogs/EditNewsDialog";
import EditNewsPicDialog from "@/components/admin/News/Dialogs/EditNewsPicDialog";
import DeleteNewsDialog from "@/components/admin/News/Dialogs/DeleteNewsDialog";

export default {
  name: "NewsItem",
  components: {DeleteNewsDialog, EditNewsPicDialog, EditNewsDialog},
  mounted() {
    this.api_call()
  },
  computed: {
    ...mapState({
      data: state => state.Admin.admin.news.news,
      loading : state => state.Admin.admin.loading,
    })
  },
  methods: {
    api_call() {
      this.$store.dispatch('get_news_item', {id: this.$route.params.id}).catch(() => {
      })

    }
  }
}
</script>

<style scoped>

</style>